import React from 'react';

const CustomerInfo = ({ customer }) => {
  return (
    <div className="space-y-1 text-sm">
      <strong className="block text-gray-900">{customer.customer_name}</strong>
      <div>📞 {customer.contact_number}</div>
      <div>🏢 {customer.business_name}</div>
      <div>📍 {customer.address}</div>
      {customer.domain && (
        <div>
          <a
            href={/^https?:\/\//.test(customer.domain) ? customer.domain : `http://${customer.domain}`}
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline hover:text-blue-800 transition"
          >
            🌐 {customer.domain}
          </a>
        </div>
      )}
    </div>
  );
};

export default CustomerInfo;
